import Vue from "vue";
import Vuex from "vuex";

// Modules
import administrators from "./modules/administrators/";
import after_sales from "./modules/after_sales/";
import after_sale_status from "./modules/after_sale_status/";
import auth from "./modules/auth/";
import branches from "./modules/branches/";
import commissions from "./modules/commissions/";
import contract_status from "./modules/contract_status/";
import contracts from "./modules/contracts/";
import defaults from "./modules/defaults/";
import downloadBills from "./modules/download_bills/";
import fuels from "./modules/fuels/";
import functionalities from "./modules/functionalities/";
import groups from "./modules/groups/";
import integrations from "./modules/integrations/";
import link_customers_to_contracts from "./modules/link_customers_to_contracts/";
import manufacturers from "./modules/manufacturers/";
import medias from "./modules/medias/";
import menu from "./modules/menu/";
import models from "./modules/models/";
import modules from "./modules/modules/";
import pending_reasons from "./modules/pending_reasons";
import plans from "./modules/plans/";
import profiles from "./modules/profiles/";
import profileCommissions from "./modules/profile_commissions/";
import proposals from "./modules/proposals/";
import standardImports from "./modules/standard_imports/";
import syncContractsAndAfterSales from "./modules/sync_contracts_and_after_sales/";
import teams from "./modules/teams/";
import type_of_payments from "./modules/type_of_payments/";
import type_sales from "./modules/type_sales/";
import users from "./modules/users/";
import configurations from "./modules/configurations/";
import charges from "./modules/charges";
import reports from "./modules/reports";
import lead_status from "./modules/lead_status";
import lead_comments from "./modules/lead_comments";
import lead from "./modules/lead";

Vue.use(Vuex);

let vuex = new Vuex.Store({
  modules: {
    administrators,
    after_sales,
    after_sale_status,
    auth,
    branches,
    commissions,
    contract_status,
    contracts,
    defaults,
    downloadBills,
    fuels,
    functionalities,
    integrations,
    groups,
    link_customers_to_contracts,
    manufacturers,
    medias,
    menu,
    models,
    modules,
    pending_reasons,
    plans,
    profiles,
    profileCommissions,
    proposals,
    standardImports,
    syncContractsAndAfterSales,
    teams,
    type_of_payments,
    type_sales,
    users,
    configurations,
    charges,
    reports,
    lead_status,
    lead,
    lead_comments
  }
});

export default vuex;
